
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crematorium-price/region/[sido]/[sigungu]",
      function () {
        return require("private-next-pages/crematorium-price/region/[sido]/[sigungu]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crematorium-price/region/[sido]/[sigungu]"])
      });
    }
  